(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mattea-measurement-guide-modal"] && !Shopify.designMode) return;
  try {
    class MatteaMeasurementGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-mattea-guide-open]');
      this.closeButton = this.querySelector('[data-mattea-guide-close]');

      this.openButton?.addEventListener('click', () => this.dialog?.showModal());
      this.closeButton?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      const productSection = this.closest('.shopify-section');
      const variantPicker = productSection?.querySelector('variant-picker');
      if (variantPicker) variantPicker.insertAdjacentElement('afterend', this);
    }
  }

  if (!customElements.get('mattea-measurement-guide')) {
    customElements.define('mattea-measurement-guide', MatteaMeasurementGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
